import { Box } from '@mui/material';
import { Prompt } from 'api/model';
import ScopeIndicator from 'components/indicators/ScopeIndicator';

type PromptRendererProps = {
  prompt?: Prompt;
  fallback: string;
};

const PromptRenderer = ({ prompt, fallback }: PromptRendererProps) => {
  if (!prompt) return <span>{fallback}</span>;

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%" gap={1}>
      <span>{prompt.prompt_name}</span>
      <ScopeIndicator isGlobal={prompt.project_id == null} />
    </Box>
  );
};

export default PromptRenderer;
